//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './EditingLockClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type LockEditingLockQueryParameters = {
  documentId?: number | undefined ;
}

export type RelockEditingLockQueryParameters = {
  documentId?: number | undefined ;
  deleteSharePointFileIfPresent?: boolean | undefined ;
}

export type UnlockEditingLockQueryParameters = {
  documentId?: number | undefined ;
}

export type CheckLockEditingLockQueryParameters = {
  documentId?: number | undefined ;
}

export function lockUrl(documentId?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/editing-lock/lock?";
if (documentId === null)
    throw new Error("The parameter 'documentId' cannot be null.");
else if (documentId !== undefined)
    url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function lockMutationKey(documentId?: number | undefined): MutationKey {
  return trimArrayEnd([
      'EditingLockClient',
      'lock',
      documentId as any,
    ]);
}

/**
 * Tries to lock document with the current client session or prolong existing lock.
If document is already locked with another session, throws ValidationException.
 * @param documentId (optional) 
 */
export function useLockMutation<TContext>(documentId?: number | undefined, options?: Omit<UseMutationOptions<Types.RefDocumentEditingUserDto, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.RefDocumentEditingUserDto, unknown, void, TContext> {
  const key = lockMutationKey(documentId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.lock(documentId),
    mutationKey: key,
  });
}
  
type Lock__MutationParameters = LockEditingLockQueryParameters

/**
 * Tries to lock document with the current client session or prolong existing lock.
If document is already locked with another session, throws ValidationException.
 * @param documentId (optional) 
 */
export function useLockMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.RefDocumentEditingUserDto, unknown, Lock__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: LockEditingLockQueryParameters}): UseMutationResult<Types.RefDocumentEditingUserDto, unknown, Lock__MutationParameters, TContext> {
  const key = lockMutationKey(options?.parameters?.documentId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Lock__MutationParameters) => Client.lock(data.documentId ?? options?.parameters?.documentId!),
  mutationKey: key,
});
}
  
export function relockUrl(documentId?: number | undefined, deleteSharePointFileIfPresent?: boolean | undefined): string {
  let url_ = getBaseUrl() + "/api/editing-lock/relock?";
if (documentId === null)
    throw new Error("The parameter 'documentId' cannot be null.");
else if (documentId !== undefined)
    url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
if (deleteSharePointFileIfPresent === null)
    throw new Error("The parameter 'deleteSharePointFileIfPresent' cannot be null.");
else if (deleteSharePointFileIfPresent !== undefined)
    url_ += "deleteSharePointFileIfPresent=" + encodeURIComponent("" + deleteSharePointFileIfPresent) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function relockMutationKey(documentId?: number | undefined, deleteSharePointFileIfPresent?: boolean | undefined): MutationKey {
  return trimArrayEnd([
      'EditingLockClient',
      'relock',
      documentId as any,
      deleteSharePointFileIfPresent as any,
    ]);
}

/**
 * Tries to lock document with the current client session.
If document is already locked with another session, unlocks document and locks it again with the current session.
 * @param documentId (optional) 
 * @param deleteSharePointFileIfPresent (optional) 
 */
export function useRelockMutation<TContext>(documentId?: number | undefined, deleteSharePointFileIfPresent?: boolean | undefined, options?: Omit<UseMutationOptions<Types.RefDocumentEditingUserDto, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.RefDocumentEditingUserDto, unknown, void, TContext> {
  const key = relockMutationKey(documentId, deleteSharePointFileIfPresent);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.relock(documentId, deleteSharePointFileIfPresent),
    mutationKey: key,
  });
}
  
type Relock__MutationParameters = RelockEditingLockQueryParameters

/**
 * Tries to lock document with the current client session.
If document is already locked with another session, unlocks document and locks it again with the current session.
 * @param documentId (optional) 
 * @param deleteSharePointFileIfPresent (optional) 
 */
export function useRelockMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.RefDocumentEditingUserDto, unknown, Relock__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RelockEditingLockQueryParameters}): UseMutationResult<Types.RefDocumentEditingUserDto, unknown, Relock__MutationParameters, TContext> {
  const key = relockMutationKey(options?.parameters?.documentId!, options?.parameters?.deleteSharePointFileIfPresent!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Relock__MutationParameters) => Client.relock(data.documentId ?? options?.parameters?.documentId!, data.deleteSharePointFileIfPresent ?? options?.parameters?.deleteSharePointFileIfPresent!),
  mutationKey: key,
});
}
  
export function unlockUrl(documentId?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/editing-lock?";
if (documentId === null)
    throw new Error("The parameter 'documentId' cannot be null.");
else if (documentId !== undefined)
    url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function unlockMutationKey(documentId?: number | undefined): MutationKey {
  return trimArrayEnd([
      'EditingLockClient',
      'unlock',
      documentId as any,
    ]);
}

/**
 * Tries to unlock document locked by the current client session.
If document is locked by another session, throws ValidationException.
 * @param documentId (optional) 
 */
export function useUnlockMutation<TContext>(documentId?: number | undefined, options?: Omit<UseMutationOptions<Types.RefDocumentEditingUserDto, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.RefDocumentEditingUserDto, unknown, void, TContext> {
  const key = unlockMutationKey(documentId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.unlock(documentId),
    mutationKey: key,
  });
}
  
type Unlock__MutationParameters = UnlockEditingLockQueryParameters

/**
 * Tries to unlock document locked by the current client session.
If document is locked by another session, throws ValidationException.
 * @param documentId (optional) 
 */
export function useUnlockMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<Types.RefDocumentEditingUserDto, unknown, Unlock__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: UnlockEditingLockQueryParameters}): UseMutationResult<Types.RefDocumentEditingUserDto, unknown, Unlock__MutationParameters, TContext> {
  const key = unlockMutationKey(options?.parameters?.documentId!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Unlock__MutationParameters) => Client.unlock(data.documentId ?? options?.parameters?.documentId!),
  mutationKey: key,
});
}
  
export function checkLockUrl(documentId?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/editing-lock?";
if (documentId === null)
    throw new Error("The parameter 'documentId' cannot be null.");
else if (documentId !== undefined)
    url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let checkLockDefaultOptions: Omit<UseQueryOptions<Types.RefDocumentEditingUserDto, unknown, Types.RefDocumentEditingUserDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.RefDocumentEditingUserDto, unknown, Types.RefDocumentEditingUserDto>, 'queryFn'>> = {
};
export function getCheckLockDefaultOptions() {
  return checkLockDefaultOptions;
};
export function setCheckLockDefaultOptions(options: typeof checkLockDefaultOptions) {
  checkLockDefaultOptions = options;
}

export function checkLockQueryKey(documentId?: number | undefined): QueryKey;
export function checkLockQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { documentId,  } = params[0] as CheckLockEditingLockQueryParameters;

    return trimArrayEnd([
        'EditingLockClient',
        'checkLock',
        documentId as any,
      ]);
  } else {
    return trimArrayEnd([
        'EditingLockClient',
        'checkLock',
        ...params
      ]);
  }
}
export function __checkLock(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.checkLock(
      context.queryKey[2] as number | undefined,axiosConfig    );
}

export function useCheckLockQuery<TSelectData = Types.RefDocumentEditingUserDto, TError = unknown>(dto: CheckLockEditingLockQueryParameters, options?: Omit<UseQueryOptions<Types.RefDocumentEditingUserDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;

export function useCheckLockQuery<TSelectData = Types.RefDocumentEditingUserDto, TError = unknown>(documentId?: number | undefined, options?: Omit<UseQueryOptions<Types.RefDocumentEditingUserDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useCheckLockQuery<TSelectData = Types.RefDocumentEditingUserDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.RefDocumentEditingUserDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let documentId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ documentId,  } = params[0] as CheckLockEditingLockQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [documentId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.RefDocumentEditingUserDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __checkLock(context, axiosConfig) : __checkLock,
    queryKey: checkLockQueryKey(documentId),
    ...checkLockDefaultOptions as unknown as Omit<UseQueryOptions<Types.RefDocumentEditingUserDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}

export function setCheckLockData(queryClient: QueryClient, updater: (data: Types.RefDocumentEditingUserDto | undefined) => Types.RefDocumentEditingUserDto, documentId?: number | undefined) {
  queryClient.setQueryData(checkLockQueryKey(documentId),
    updater
  );
}

export function setCheckLockDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.RefDocumentEditingUserDto | undefined) => Types.RefDocumentEditingUserDto) {
  queryClient.setQueryData(queryKey, updater);
}